// This file was auto-generated by Fern from our API Definition.
export var BodyCreateSimpleTestsetFromFile;
(function (BodyCreateSimpleTestsetFromFile) {
    BodyCreateSimpleTestsetFromFile.FileType = {
        Csv: "csv",
        Json: "json",
    };
})(BodyCreateSimpleTestsetFromFile || (BodyCreateSimpleTestsetFromFile = {}));
